<div class="searchbar-wrapper d-flex align-items-center">
  <div class="container align-items-center d-flex">
    <i class="fa-light fa-magnifying-glass" (click)="searchQuery()"></i>
    <div class="search-input">
      <input id="searchInput" style="font-size: 70px; outline: none;" name="searchInput" [formControl]="search"
        type="text" placeholder="Tornillos, anclajes, conectores...">
    </div>
  </div>
</div>